// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3d6Ns","list":"PatternAutocomplete_list__8IVwX"};